import common from './common'

export default {
    listMedicalField() {
      return window.vm.$store.state.login.userInfo.loginMedicalFields;
    },

    listTeams() {
      return window.vm.$store.state.login.userInfo.loginTeams;
    },
    
    listProduct() {
      return common.get('/rocheManage/external/externalProduct/list',{pageSize:999999, pageNo:1});
    },
    
    listDepart() {
      return window.vm.$store.state.login.userInfo.loginDeparts;
    },

    listTreatmentArea() {
      return new Promise((resolve, reject) => {
        common.get('/rocheManage/external/externalAreaRelation/list',{pageSize:999999, pageNo:1})
            .then(res => {
              let treatmentArray = [];
              res.records.forEach(r => {
                if(r.meetingProp == '1' && !treatmentArray.some(t => t.id == r.areaDbId)) {
                  treatmentArray.push({
                    id: r.areaDbId,
                    treatmentAreaName: r.areaName
                  })
                }
              })
              resolve(treatmentArray)
            })
      });
    },

    listDiseaseArea() {
      
      return new Promise((resolve, reject) => {
        common.get('/rocheManage/external/externalAreaRelation/list',{pageSize:999999, pageNo:1})
            .then(res => {
              let treatmentArray = [];
              res.records.forEach(r => {
                if(r.meetingProp !== '1' && !treatmentArray.some(t => t.id == r.areaDbId)) {
                  treatmentArray.push({
                    id: r.areaDbId,
                    diseaseAreaName: r.areaName
                  })
                }
              })
              resolve(treatmentArray)
            })
      });
    },

    listCountry() {
      return common.get('/rocheManage/external/externalCountry/list',{pageSize:999999, pageNo:1});
    },

    listProvince(params) {
      if(!params){
        params = {}
      }
      params.pageSize = 999999;
      params.pageNo = 1;
      return common.get('/rocheManage/external/externalProvince/list',params);
    },

    listCity(params) {
      params.pageSize = 999999;
      params.pageNo = 1;
      return common.get('/rocheManage/external/externalCity/list',params);
    },
    
    listHospitalLevel(params) {
      if(!params){
        params = {}
      }
      params.pageSize = 999999;
      params.pageNo = 1;
      return common.get('/rocheManage/bus/busHospitalLevel/list',params);
    },
    
    listSpeakerLevel(params) {
      if(!params){
        params = {}
      }
      params.pageSize = 999999;
      params.pageNo = 1;
      return common.get('/rocheManage/bus/busSpeakerLevel/list',params);
    },
    
    listYear() {
      return common.get('/rocheManage/sys/dict/getYearList',{});
    },
    
    listQuarter() {
      return common.get('/rocheManage/sys/dict/getDictItemsByCode/quarter',{});
    },
    
    listCostCenter() {
      return common.get('/rocheManage/external/externalCostCenter/list',{costType:'1'});
    },
    
    listWbsCode() {
      return common.get('/rocheManage/external/externalCostCenter/list',{costType:'2'});
    },
    
    listMyApplicationStatus() {
      return [
        {value:'1',text:'待提交'},
        {value:'2',text:'审批中'},
        {value:'4',text:'审批通过'},
        {value:'5',text:'审批拒绝'},
        {value:'7',text:'已取消'},
      ];
    },
    
    listMyLibraryStatus() {
      return [
        {value:'3',text:'审批中'},
        {value:'4',text:'审批通过'},
        {value:'5',text:'审批拒绝'},
        {value:'7',text:'已取消'},
      ];
    },
    
    listMyTaskStatus() {
      return [
        {value:'3',text:'待审批'},
        {value:'4',text:'审批通过'},
        {value:'5',text:'审批拒绝'},
        {value:'7',text:'已取消'},
      ];
    },
    
    listMeetingStatus() {
      return [
        {value:'1',text:'待提交'},
        {value:'2',text:'审批中'},
        {value:'3',text:'待审批'},
        {value:'4',text:'审批通过'},
        {value:'5',text:'审批拒绝'},
        {value:'7',text:'已取消'},
      ];
    },
    
    listMeetingTaskStatus() {
      return [
        {value:'3',text:'待审批'},
        {value:'4',text:'审批通过'},
        {value:'5',text:'审批拒绝'},
        {value:'7',text:'已取消'},
      ];
    },
    
    listCompanyStrategy() {
      return common.get('/rocheManage/sys/dict/getDictItemsByCode/company_strategy',{});
    },
    
    listMeetingProp() {
      return common.get('/rocheManage/sys/dict/getDictItemsByCode/meeting_prop',{});
    },
    
    listMeetingModality() {
      return common.get('/rocheManage/sys/dict/getDictItemsByCode/meeting_modality',{});
    },
    
    listMeetingType() {
      return common.get('/rocheManage/sys/dict/getDictItemsByCode/meeting_type',{});
    },
    
    listRole() {
      return common.get('/rocheManage/sys/role/queryall',{});
    },
    
    listDomainResult(params) {
      if(!params){
        params = {}
      }
      params.pageSize = 999999;
      params.pageNo = 1;
      return common.get('/rocheManage/bus/busTreatResult/list',params);
    },
    
    listMeetingSystem() {
      return common.get('/rocheManage/sys/dict/getDictItemsByCode/meeting_system',{});
    },
    
    listAoneExeStatus() {
      return common.get('/rocheManage/sys/dict/getDictItemsByCode/aone_exe_status',{});
    },
    
    listStrategy(params) {
      if(!params){
        params = {}
      }
      params.pageSize = 999999;
      params.pageNo = 1;
      return common.get('/rocheManage/bus/busStrategy/list',params);
    },
    
    listOffice(params) {
      if(!params){
        params = {}
      }
      params.pageSize = 999999;
      params.pageNo = 1;
      return common.get('/rocheManage/bus/busOffice/list',params);
    },
    
    listMeetingTimeInt() {
      return common.get('/rocheManage/sys/dict/getDictItemsByCode/meeting_time_int',{});
    },
    
    listSysErrorTip() {
      return common.get('/rocheManage/sys/dict/getDictItemsByCode/sys_error_tip',{});
    },
    
    listSysTip() {
      return common.get('/rocheManage/sys/dict/getDictItemsByCode/sys_tip',{});
    },
    
    listMeetingGsdType() {
      return common.get('/rocheManage/sys/dict/getDictItemsByCode/meeting_gsd_type',{});
    },
    
    listMeetingGsdTypeSub1() {
      return common.get('/rocheManage/sys/dict/getDictItemsByCode/meeting_gsd_type_sub_1',{});
    },
    
    listMeetingGsdTypeSub2() {
      return common.get('/rocheManage/sys/dict/getDictItemsByCode/meeting_gsd_type_sub_2',{});
    },
    
    listMeetingGsdTypeSub3() {
      return common.get('/rocheManage/sys/dict/getDictItemsByCode/meeting_gsd_type_sub_3',{});
    },
}


// WEBPACK FOOTER //
// ./src/api/basedata.js